import { Struct } from '@bufbuild/protobuf'
import { AiChatEventPayload } from 'poc-ai-biz-irdb_domain-model'
import {
  AiChatEventPayloadClientInfo,
  AiChatPageContext,
  AiChatAvailableAction,
  AiChatParamDefinition as ProtoAiChatParamDefinition,
  AiChatParamDefinitionPrimitive,
  AiChatParamDefinitionObject,
  AiChatParamDefinitionArray,
} from './_gen/aiChat_pb'

type ClientInfo = Extract<AiChatEventPayload, { type: 'clientInfo' }>
type DomainAiChatParam = ClientInfo['availableActions'][number]['parameterDefinition']['properties'][string]

// domain-model ClientInfo を Protobuf AiChatEventPayloadClientInfo に変換
export function convertAiChatParamDefinitionTypeToProto(param: DomainAiChatParam): ProtoAiChatParamDefinition['paramType'] {
  switch (param.type) {
    case 'string':
      return {
        case: 'primitive',
        value: new AiChatParamDefinitionPrimitive({
          type: 'string',
          enumValues: param.enum || [],
        }),
      }
    case 'number':
      return {
        case: 'primitive',
        value: new AiChatParamDefinitionPrimitive({
          type: 'number',
        }),
      }
    case 'boolean':
      return {
        case: 'primitive',
        value: new AiChatParamDefinitionPrimitive({
          type: 'boolean',
        }),
      }
    case 'object':
      return {
        case: 'object',
        value: new AiChatParamDefinitionObject({
          properties: Object.entries(param.properties ?? {}).reduce(
            (obj, [propKey, propParam]) => {
              obj[propKey] = convertAiChatParamDefinitionToProto(propParam)
              return obj
            },
            {} as Record<string, ProtoAiChatParamDefinition>,
          ),
        }),
      }
    case 'array':
      return {
        case: 'array',
        value: new AiChatParamDefinitionArray({
          items: convertAiChatParamDefinitionToProto(param.items),
        }),
      }
    default:
      throw new Error(`Unsupported parameter type: ${(param as any).type}`)
  }
}

export function convertAiChatParamDefinitionToProto(param: DomainAiChatParam): ProtoAiChatParamDefinition {
  const paramType: ProtoAiChatParamDefinition['paramType'] = convertAiChatParamDefinitionTypeToProto(param)
  return new ProtoAiChatParamDefinition({
    description: param.description,
    paramType,
  })
}

export function convertClientInfoToProto(clientInfo: ClientInfo): AiChatEventPayloadClientInfo {
  const pageContext = new AiChatPageContext({
    ...clientInfo.pageContext,
  })

  const availableActions = clientInfo.availableActions.map((action) => {
    return new AiChatAvailableAction({
      actionType: action.actionType,
      description: action.description,
      parameterDefinition: Struct.fromJson(action.parameterDefinition),
    })
  })

  return new AiChatEventPayloadClientInfo({
    type: clientInfo.type,
    pageContext,
    availableActions,
  })
}
